import React, { FC, useState } from 'react';

import { Box } from '@mui/material';
import {
  BarChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
  CartesianGrid,
  Legend,
  TooltipProps,
} from 'recharts';

import { formatLargeNumber } from 'utils/helpers/currencyFormatter';
import { neutrals } from 'utils/styles/color';
import { CustomLegend2 } from './components/Legend2';
import CustomTooltip2 from './components/Tooltip2';
import { CombinedChartData, ServiceType } from './helpers';

const DealInvoiceChart2: FC<{
  items: CombinedChartData[];
  invoiceState?: string;
  serviceTypes?: ServiceType[];
  currency: string;
}> = ({ currency, items }) => {
  const [focusedBar, setFocusedBar] = useState<CombinedChartData | null>(null);
  const [spacing, setSpacing] = useState<number>(0);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const renderTooltipWithProps = () => (props: TooltipProps<any, any>) =>
    <CustomTooltip2 {...props} categoryMap={focusedBar} currency={currency} />;

  return (
    <Box height={210}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={items}
          barGap={4}
          onMouseMove={(state: {
            activeTooltipIndex?: number;
            isTooltipActive?: boolean;
          }) => {
            const { isTooltipActive, activeTooltipIndex } = state;
            if (isTooltipActive) {
              setFocusedBar(items[activeTooltipIndex as number] || null);
            } else {
              setFocusedBar(null);
            }
          }}
          onMouseLeave={() => setFocusedBar(null)}
        >
          <CartesianGrid vertical={false} />
          {/* {serviceTypes && serviceTypes.includes('gcp_rev') && (
            <Bar
              stackId="a"
              dataKey="gcp_rev"
              fill="#4C8EE6"
              barSize={20}
              radius={[5, 5, 0, 0]}
            />
          )}
          {serviceTypes && serviceTypes.includes('gcp_pipeline') && (
            <Bar
              stackId="a"
              dataKey="gcp_pipeline"
              fill="#93C5FD"
              barSize={20}
              radius={[5, 5, 0, 0]}
            />
          )}
          {serviceTypes && serviceTypes.includes('psfdaf_rev') && (
            <Bar
              stackId="a"
              dataKey="psfdaf_rev"
              fill="#E75858"
              barSize={20}
              radius={[5, 5, 0, 0]}
            />
          )}
          {serviceTypes && serviceTypes.includes('psfdaf_pipeline') && (
            <Bar
              stackId="a"
              dataKey="psfdaf_pipeline"
              fill="#FF9999"
              barSize={20}
              radius={[5, 5, 0, 0]}
            />
          )} */}

          <Bar stackId="a" dataKey="gcp_rev" fill="#4C8EE6" barSize={20} />

          <Bar stackId="a" dataKey="gcp_pipeline" fill="#93C5FD" barSize={20} />

          <Bar stackId="a" dataKey="psfdaf_rev" fill="#E75858" barSize={20} />

          <Bar
            stackId="a"
            dataKey="psfdaf_pipeline"
            fill="#FF9999"
            barSize={20}
          />

          {/* <Bar
            stackId="a"
            dataKey="total"
            barSize={20}
            shape={PipelineBarWithBorder('#FF9999')}
            activeBar={PipelineBarWithBorder('#FF9999')}
          /> */}
          <XAxis
            dataKey="monthKey"
            tick={{
              fontSize: 12,
              stroke: neutrals[700],
              strokeWidth: 0,
              color: neutrals[700],
            }}
            // tick formatting done in data preprocessor
            tickFormatter={(tick) => tick}
          />
          <YAxis
            width={spacing}
            tick={{
              fontSize: 12,
              stroke: neutrals[700],
              strokeWidth: 0,
              color: neutrals[700],
            }}
            tickCount={5}
            tickFormatter={(value) => {
              const displayValue = formatLargeNumber(Number(value), 'USD');
              const yAxisSpace = 27 + displayValue.length * 3;
              setSpacing((prev) => (prev > yAxisSpace ? prev : yAxisSpace));

              return displayValue;
            }}
          />
          <Tooltip
            cursor={{ fill: '#A1A8B2', opacity: 0.3, type: '' }}
            content={renderTooltipWithProps()}
            // labelFormatter={() => ''}
          />
          <Legend content={<CustomLegend2 />} />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default DealInvoiceChart2;
